export const routes = {
    app: '/',
    payin: '/payin',
    'payin-order': '/payin/orders/:orderId',
    'payin-history': '/payin/history',
    payout: '/payout',
    'payout-order': '/payout/orders/:orderId',
    'payout-history': '/payout/history',
    history: '/history',
    settings: '/settings',
    'privacy-policy': '/privacy-policy',
    login: '/login',
    registration: '/registration',
    recover: '/recover',
} as const;
